import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { withStyles } from "@material-ui/core/styles";
import styles from './clients.module.scss';
import { Button, Switch } from '@material-ui/core';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import CallOutlinedIcon from '@mui/icons-material/CallOutlined';
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBuilding } from '@fortawesome/free-regular-svg-icons';
import { AspectRatio } from '@mui/icons-material';
import { CommonConfirmationDialog } from '../../components/DialogComponent/SupplyDataDialog';

const AntSwitch = withStyles((theme) => ({
    root: {
        width: 28,
        height: 16,
        padding: 0,
        display: "flex",
    },
    switchBase: {
        padding: 2,
        color: theme.palette.grey[500],
        "&$checked": {
            transform: "translateX(12px)",
            color: theme.palette.common.white,
            "& + $track": {
                opacity: 1,
                backgroundColor: theme.palette.primary.main,
                borderColor: theme.palette.primary.main,
            },
        },
    },
    thumb: {
        width: 12,
        height: 12,
        boxShadow: "none",
    },
    track: {
        border: `1px solid ${theme.palette.grey[500]}`,
        borderRadius: 16 / 2,
        opacity: 1,
        backgroundColor: theme.palette.common.white,
    },
    checked: {},
}))(Switch);

const MobileViewClientTable = ({ client, OnSwitchChange }) => {
    const navigate = useNavigate();

    const [confirmationDialog, setConfirmationDialog] = useState({
        open: false,
        client: null,
        newStatus: false,
    });

    const handleSwitchChange = (client) => {
        const newStatus = !client?.status;

        setConfirmationDialog({
        open: true,
        client: client,
        newStatus: newStatus,
        });
    };

    const handleConfirmStatusChange = () => {
        if (OnSwitchChange && confirmationDialog?.client) {
        OnSwitchChange(confirmationDialog?.client, confirmationDialog?.newStatus);
        }

        setConfirmationDialog({
        open: false,
        client: null,
        newStatus: false,
        });
    };

    const handleCloseConfirmation = () => {
        setConfirmationDialog({
        open: false,
        client: null,
        newStatus: false,
        });
    };

    return (
        <>
        <div className={`${styles.card} dark:bg-[#1A1F2C] shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)] dark:border-0`}>
            <div className="d-flex flex-space-between flex-center mb-14">
                <div className={styles.clientInfo}>
                    {client?.avatar ? (
                        <div className={styles.avatarWrapper}>
                            <AspectRatio ratio={1 / 1}>
                                <img
                                    src={client.avatar}
                                    alt={client.name}
                                    className={styles.avatarImage}
                                />
                            </AspectRatio>
                        </div>
                    ) : (
                        <div className={styles.avatarFallback}>
                            <span className={styles.avatarInitial}>
                                {client?.clientName.charAt(0)}
                            </span>
                        </div>
                    )}
                    <div>
                        <h3 className={`${styles.clientName} dark:text-white`}>{client?.clientName}</h3>
                        {/* <p className='mv-5' style={{ color: "#6B7280", fontSize: "14px" }}>{client?.company}</p> */}
                    </div>
                </div>
            </div>

            <div style={{ fontSize: "14px" }}>
                <div className={styles.infoRow}>
                    <span className={styles.label}><FontAwesomeIcon icon={faBuilding} className={`${styles.iconSmall} mr-4`} /> ID:</span>
                    <span className="font-mono dark:text-white">{client?.clientNumbers}</span>
                </div>
                {client?.primaryContact && (
                    <div className={styles.infoRow2}>
                        <span className={styles.label}><CallOutlinedIcon className={`${styles.iconSmall} mr-4`} /> Phone:</span>
                        <span className='dark:text-white'>{client?.primaryContact}</span>
                    </div>
                )}
                {client?.email && (
                    <div className={styles.infoRow2}>
                        <span className={styles.label}><MailOutlineIcon className={`${styles.iconSmall} mr-4`} /> Email:</span>
                        <span className={styles.email}><a href={`https://mail.google.com/mail/?view=cm&fs=1&to=${client?.email}`} rel="noopener noreferrer" target="_blank" className="resLinks" style={{ overflowWrap: "anywhere" }}>
                            {client?.email}
                        </a></span>
                    </div>
                )}
                <div className={styles.infoRow2}>
                    <span className={styles.label}><CalendarMonthOutlinedIcon className={`${styles.iconSmall} mr-4`} /> Shifts:</span>
                    <span className='dark:text-white'>{client?.shiftData ? [...Object.keys(client?.shiftData)]?.length : ''}</span>
                </div>
            </div>

            <div className="d-flex flex-space-between flex-center mt-16">
                <div className="d-flex flex-center" style={{ gap: "8px" }}>
                    {client?.shiftData && Object.keys(client?.shiftData)?.length > 0 && (
                    <AntSwitch
                        checked={client?.status}
                        onChange={() => handleSwitchChange(client)}
                        color="primary"
                        name="switchStatus"
                        inputProps={{ "aria-label": "switchStatus" }}
                    />
                    )}
                    <span className={client?.status ? styles.active : styles.inactive}>
                        {!client?.status && (!client?.shiftData || Object.keys(client?.shiftData)?.length === 0) ? 'Pending' : client?.status ? 'Active' : 'Inactive'}
                    </span>
                </div>
                <div className={styles.buttonGroup}>
                    <Button
                        variant="outline"
                        size="sm"
                        onClick={() => navigate(`/peoples/createClient/${client?.id}`)}
                        className={styles.viewButton}
                    >
                        <VisibilityOutlinedIcon className="mr-5" />
                        View
                    </Button>
                </div>
            </div>
        </div>
            <CommonConfirmationDialog
                open={confirmationDialog?.open}
                onConfirm={handleConfirmStatusChange}
                onClose={handleCloseConfirmation}
                title={confirmationDialog?.newStatus ? "Active Client" : "Inactive Client"}
                message={
                  confirmationDialog?.newStatus
                    ? "Are you sure you want to active this client?"
                    : "Are you sure you want to inactive this client?\nThis action will permanently revoke the client's access to their account, and it cannot be undone.\nPlease proceed only if you are certain."
                }
                // meessge1={confirmationDialog.client ? `Client: ${confirmationDialog.client.clientName}` : ''}
                buttonTitle="Confirm"
            />
        </>
    );
};

export default MobileViewClientTable;